// @ts-nocheck
import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from '@material-ui/core';
import { CompareArrows } from '@material-ui/icons';
import ReceiptsModal from '../components/modals/ReceiptsModal';

function useAutomationTools({
  hasAutomation,
  allowedAutomationActions = ['receipt', 'dispatch'],
  products,
  processTypes,
  warehouses,
  packagingTypes,
  suppliers,
  accounts,
  actions,
}) {
  const { t } = useTranslation();

  const [receiptsModalOpen, setReceiptsModalOpen] = useState(false);
  const [, setDispatchsModalOpen] = useState(false);

  const handleOpenReceiptsModal = useCallback(() => setReceiptsModalOpen(true), []);
  const handleCloseReceiptsModal = useCallback(() => setReceiptsModalOpen(false), []);
  const handleOpenDispatchsModal = useCallback(() => setDispatchsModalOpen(true), []);

  const automationListItems = [
    allowedAutomationActions.includes('receipt')
      ? {
        label: t('processTypes.actions.receipt'),
        onClick: handleOpenReceiptsModal,
        icon: CompareArrows,
      }
      : null,
    allowedAutomationActions.includes('dispatch')
      ? {
        label: t('processTypes.actions.dispatch'),
        onClick: handleOpenDispatchsModal,
        icon: CompareArrows,
      }
      : null,
  ].filter(Boolean);

  const automationMenuItems = hasAutomation && automationListItems.length > 0
    ? [
      { label: '', component: Divider, listItems: [] },
      {
        label: t('processTypes.actions.parameterize'),
        listItems: automationListItems,
      },
    ]
    : [];

  const filteredProcessTypes = Object.fromEntries(
    Object.entries(processTypes || {}).filter(([_, pt]) => pt.name !== 'Recepción'),
  );

  const AutomationModals = useCallback(
    () => (
      <>
        <ReceiptsModal
          open={receiptsModalOpen}
          onClose={handleCloseReceiptsModal}
          products={products}
          processTypes={filteredProcessTypes}
          warehouses={warehouses}
          packagingTypes={packagingTypes}
          actions={actions}
          hasAutomationPermission={hasAutomation}
          accounts={accounts}
          suppliers={suppliers}
        />
      </>
    ),
    [
      receiptsModalOpen,
      products,
      filteredProcessTypes,
      warehouses,
      packagingTypes,
      suppliers,
      accounts,
      actions,
      hasAutomation,
      allowedAutomationActions,
    ],
  );

  return { automationMenuItems, AutomationModals };
}

export default useAutomationTools;
